module.exports = __webpack_public_path__ + "media/Jason_de_ridder_compilatie.fbfb8a91.mp3";